import { render, staticRenderFns } from "./SearchDocHistory.vue?vue&type=template&id=6b400268&scoped=true&"
import script from "./SearchDocHistory.vue?vue&type=script&lang=js&"
export * from "./SearchDocHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b400268",
  null
  
)

export default component.exports